import { css } from "@emotion/react";

export const rangeFilter = css`
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const rangeInput = css`
  margin-top: 5px;
`;
